import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizSpin } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../../header'
import Criteria from '../../components/criteria'
import AcceptanceResults from '../../components/acceptanceResults'
import Result from '../../components/result'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/review/result/send') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('reviewResultSend', record)
        } else {
            record = Session.get('reviewResultSend') || {}
        }
    }
    return record
}

class ReviewResultSend extends WizContainer {

    componentName = 'ReviewResultSend'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._detail()
    }

    _detail = () => {
        const { id, processContentId } = this.state.record
        this.doActions([{
            path: 'counselingProcess/acceptanceResults',
            payload: {
                key: 'reviewAcceptanceResults@' + processContentId,
                apiParams: {
                    processId: processContentId,
                    type: 3
                }
            }
        }, {
            path: 'counselingProcess/evaluationCriteria',
            payload: {
                key: 'reviewEvaluationCriteriaSend@' + processContentId,
                apiParams: {
                    processId: processContentId,
                    type: 3
                }
            }
        }, {
            path: 'counselingProcess/getKpiCycleList',
            payload: {
                key: 'getKpiCycleListSend@' + processContentId,
                apiParams: {
                    fuseTutorId: id
                }
            }
        }, {
            path: 'counselingProcess/cameraList',
            payload: {
                key: 'cameraListSend@' + processContentId,
                apiParams: {
                    fuseTutorId: id
                }
            }
        }, {
            path: 'counselingProcess/satisfactionEvaluationGetList',
            payload: {
                key: 'satisfactionEvaluationGetListSend@' + processContentId,
                apiParams: {
                    fuseTutorId: id
                }
            }
        }])
    }

    _onSub = (values) => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/sendPreAuditOrCheck',
            payload: {
                key: 'sendReviewResult@' + processContentId,
                apiParams: {
                    processId: processContentId,
                    type: 3,
                    ...values
                }
            }
        })
    }

    propsAndStateOnChange = {
        save: this._saveOnChange.bind(this)
    }

    _saveOnChange(nextProps, nextState) {
        if (nextProps.save.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.save.msg)
        }
    }

    render() {
        let { record } = this.state
        let {
            auditAcceptanceResults,
            kpi,
            camera,
            satisfaction,
            evaluationCriteria,
            counselingProcessLoading
        } = this.props
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <CounselingHeader record={record} />
                <AcceptanceResults
                    data={auditAcceptanceResults.data}
                    title='检核验收结果'
                    type='send'
                    other={{
                        kpi: kpi.data,
                        camera: camera.data,
                        satisfaction: satisfaction.data
                    }}
                />
                <Criteria data={evaluationCriteria.data} title='检核标准' type='send' />
                <Result title='检核结果' mode='review' type='send' onSub={this._onSub} />
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId } = findParamRecord(ownProps.history)
    const evaluationCriteria = modelUtils.getModelEntity(counselingProcess, 'reviewEvaluationCriteriaSend@' + processContentId)
    const auditAcceptanceResults = modelUtils.getModelEntity(counselingProcess, 'reviewAcceptanceResults@' + processContentId)
    const save = modelUtils.getModelEntity(counselingProcess, 'sendReviewResult@' + processContentId)
    const kpi = modelUtils.getModelEntity(counselingProcess, 'getKpiCycleListSend@' + processContentId)
    const camera = modelUtils.getModelEntity(counselingProcess, 'cameraListSend@' + processContentId)
    const satisfaction = modelUtils.getModelEntity(counselingProcess, 'satisfactionEvaluationGetListSend@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        evaluationCriteria,
        auditAcceptanceResults,
        save,
        kpi,
        camera,
        satisfaction,
        ...loading
    }
}

export default connect(mapStateToProps)(ReviewResultSend)


